type ClassValue =
  | string
  | false
  | null
  | undefined
  | Record<string, boolean | undefined>;

export function cn(...args: ClassValue[]): string {
  const out: string[] = [];
  for (const arg of args) {
    if (!arg) {
      continue;
    }
    if (typeof arg === "string") {
      out.push(arg);
    } else {
      for (const [key, value] of Object.entries(arg)) {
        if (value) {
          out.push(key);
        }
      }
    }
  }
  return out.join(" ");
}
